// One-time "what's new" line Mochi whispers on each user's next visit after
// a meaningful release. Per-device (localStorage), version-keyed so future
// releases can fire their own line without re-firing this one.
//
// Bump the STORAGE_KEY suffix when shipping a new release-notes line. Old
// keys can stay in localStorage forever — they're tiny and harmless.

const STORAGE_KEY = "mochi-release-seen-2026-02-edit-and-hunger";

// Short, warm, on-brand. ONE phrase — this fires once per user, no need to
// randomise. Mentions both shipped features the user might not discover
// on their own: tap-to-edit, and task→feed-Mochi.
export const RELEASE_NOTES_LINE =
    "psst 🍡 two tiny things — tap any card to edit it, and finishing tasks feeds me rice balls now 🍙";

export function shouldShowReleaseNotes() {
    try {
        return !window.localStorage.getItem(STORAGE_KEY);
    } catch {
        // Safari private mode → just skip, don't pester.
        return false;
    }
}

export function markReleaseNotesSeen() {
    try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch { /* private mode */ }
}
